import { call, put, select } from 'redux-saga/effects';
import { Action } from '@reduxjs/toolkit';
import { hasPermissionsSaga } from 'features/permissions/sagas/hasPermissionsSaga';
import { PermissionTypes } from 'features/permissions/types';
import { selectNotificationsByScope } from 'features/notifications/notificationsSlice';
import { NotificationId } from 'features/notifications/types';
import { closeActionNotification } from 'features/notifications/thunks/closeActionNotification';
import { quizResultsCleared } from 'features/quizzes/quizzesSlice';

interface PermissionChecks {
  canManage: boolean;
  canTakePolls: boolean;
}

export function* checkPermissionsSaga() {
  const canManage: boolean = yield call(hasPermissionsSaga, PermissionTypes.managePolls);
  const canTakePolls: boolean = yield call(hasPermissionsSaga, PermissionTypes.takePolls);

  return {
    canManage,
    canTakePolls,
  };
}

export function* handleRoleChangeQuizPermissionsSaga() {
  const permissionChecks: PermissionChecks = yield call(checkPermissionsSaga);

  if (!permissionChecks.canTakePolls || permissionChecks.canManage) {
    const notifications: NotificationId[] = yield select(
      selectNotificationsByScope,
      'quiz_request_take'
    );

    if (notifications.length) {
      const cleanupNotificationThunk: Action = yield call(
        closeActionNotification,
        notifications[0]
      );
      yield put(cleanupNotificationThunk);
    }
  }

  if (!permissionChecks.canManage) {
    yield put(quizResultsCleared());
  }
}
